var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftLeftBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 800,
    viewBox: "0 0 785 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7727 748.533C-44.1781 748.552 -129.671 686.498 -169.273 600.11C-203.392 525.768 -195.719 426.343 -162.426 330.811C-123.799 219.961 -50.8318 109.121 42.0051 30.6478C66.3994 10.029 89.8878 -10.2875 116.405 -26.9683C225.091 -95.3577 293.575 -11.4316 348.807 -22.0015C395.247 -30.8654 430.414 -90.1227 475.726 -109.233C597.94 -160.664 685.742 -5.68982 654.975 128.807C619.156 285.402 306.754 748.472 56.7727 748.533Z",
    fill: "#2364AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M56.7727 748.533C-44.1781 748.552 -129.671 686.498 -169.273 600.11C-203.392 525.768 -195.719 426.343 -162.426 330.811C-123.799 219.961 -50.8318 109.121 42.0051 30.6478C66.3994 10.029 89.8878 -10.2875 116.405 -26.9683C225.091 -95.3577 293.575 -11.4316 348.807 -22.0015C395.247 -30.8654 430.414 -90.1227 475.726 -109.233C597.94 -160.664 685.742 -5.68982 654.975 128.807C619.156 285.402 306.754 748.472 56.7727 748.533Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftLeftBackground);
export default __webpack_public_path__ + "static/media/gift_leftBackground.026b1acf8833ce64d6a98cc020bea44c.svg";
export { ForwardRef as ReactComponent };